import { Action, combineReducers } from '@ngrx/store';

import { IBackAuthEntitiesState } from './entities.state';
import { BackAuthEntitiesExternalFeatureKey, BackAuthEntitiesExternalReducer } from './external/entities-external.reducer';
import { BackAuthEntitiesInternalFeatureKey, BackAuthEntitiesInternalReducer } from './internal/entities-internal.reducer';
import { BackAuthEntitiesGlobalFeatureKey, BackAuthEntitiesGlobalReducer } from './global/entities-global.reducer';

export function BackAuthEntitiesReducers (state: IBackAuthEntitiesState, action: Action)
{
    return combineReducers({
        [BackAuthEntitiesExternalFeatureKey]: BackAuthEntitiesExternalReducer,
        [BackAuthEntitiesInternalFeatureKey]: BackAuthEntitiesInternalReducer,
        [BackAuthEntitiesGlobalFeatureKey]: BackAuthEntitiesGlobalReducer
    })(state, action);
}

